import { render, staticRenderFns } from "./ReportPlayerDetailedAdmin.vue?vue&type=template&id=44f869d0"
import script from "./ReportPlayerDetailedAdmin.vue?vue&type=script&lang=js"
export * from "./ReportPlayerDetailedAdmin.vue?vue&type=script&lang=js"
import style0 from "./ReportPlayerDetailedAdmin.vue?vue&type=style&index=0&id=44f869d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports